import {arrayCascade, limit, testStakeholderIsStaff} from "./tools";
import {pureLocations} from "../factories/locations";

export class LocationCalculator {
  constructor(location, history) {
    this.location = location;
    this.history = history;
  }

  /**
   *
   * @param stakeholders
   * @returns {*}
   */
  calculateUserActionsResults(stakeholders) {
    return stakeholders.map(each => {
      const data = {...each};
      if (this.history) {
        const results = this.history
          .filter(item => {
            return !(item.id === 'T3' && this.history.findIndex(i => i.id === 'E1') < 0);
          })
          .map(item => item.action_results)
          .reduce((a, b) => a.concat(b), [])
          .filter(item => {
            const conditionI = each.id === item.stakeholder || each.title.includes(item.stakeholder);
            const conditionII = this.location.id === item.location;
            return conditionI && conditionII;
          });
        if (Object.keys(each).includes('motivation')) {
          data.motivation = results
            .filter(item => item.metric === 'Motivation')
            .map(item => item.value)
            .reduce((a, b) => a + b, each.motivation);
          data.motivation = limit(data.motivation, 0, 100);
        }
        if (Object.keys(each).includes('ability')) {
          data.ability = results
            .filter(item => item.metric === 'Ability')
            .map(item => item.value)
            .reduce((a, b) => a + b, each.ability);
          data.ability = limit(data.ability, 0, 100);
        }
        if (Object.keys(each).includes('participation')) {
          data.participation = results
            .filter(item => item.metric === 'Participation')
            .map(item => item.value)
            .reduce((a, b) => a + b, each.participation);
          data.participation = limit(data.participation, 0, 100);
        }
      }
      return data;
    });
  }

  /**
   *
   * @returns {number}
   */
  calculateAdoptionRate() {
    let adoptionRate = 0;
    if (this._historyContainsAction('E1')) {
      const pureLocation = pureLocations.find(each => each.id === this.location.id);
      arrayCascade(this.history).reverse()
        .forEach(historyState => {
          if (historyState.findIndex(each => each.id === 'E1') >= 0) {
            const calculator = new LocationCalculator(pureLocation, historyState);
            let stakeholders = calculator.calculateUserActionsResults(pureLocation.stakeholders);
            stakeholders = calculator.calculateMotivationReduction(stakeholders);
            const staff = stakeholders.filter(testStakeholderIsStaff);
            const action = historyState.slice().pop();
            const condition = staff.every(each => each.ability >= 60 && each.motivation >= 60);
            if (condition) {
              const totalStaffMotivation = staff.map(each => each.motivation).reduce((a, b) => a + b, 0);
              const avgStaffMotivation = totalStaffMotivation / staff.length;
              adoptionRate += Math.floor(avgStaffMotivation / 10) * action.weeks_required;
            }
            const conditionII = adoptionRate > 0 && staff.some(each => each.motivation < 60);
            if (conditionII) {
              adoptionRate -= 3 * action.weeks_required;
            }
          }
        });
    }
    return limit(adoptionRate, 0, 100);
  }

  /**
   *
   * @param stakeholders
   * @returns {*}
   */
  calculateCommunityParticipation(stakeholders) {
    return stakeholders.map(each => {
      const data = {...each};
      if (this._historyContainsAction('E1')) {
        if (!testStakeholderIsStaff(each)) {
          const pureLocation = pureLocations.find(each => each.id === this.location.id);
          arrayCascade(this.history).reverse()
            .forEach(historyState => {
              if (historyState.findIndex(each => each.id === 'E1') >= 0) {
                const calculator = new LocationCalculator(pureLocation, historyState);
                let stakeholders = calculator.calculateUserActionsResults(pureLocation.stakeholders);
                stakeholders = calculator.calculateMotivationReduction(stakeholders);
                const staff = stakeholders.filter(testStakeholderIsStaff);
                const action = historyState.slice().pop();
                if (action) {
                  const condition = staff.every(each => each.ability >= 60 && each.motivation >= 60);
                  if (condition) {
                    const totalStaffMotivation = staff.map(each => each.motivation).reduce((a, b) => a + b, 0);
                    const avgStaffMotivation = totalStaffMotivation / staff.length;
                    data.participation += Math.floor(avgStaffMotivation / 10) * action.weeks_required;
                  }
                  const conditionII = calculator.calculateAdoptionRate() > 0 && staff.some(each => each.motivation < 60);
                  if (conditionII) {
                    data.participation -= 3 * action.weeks_required;
                  }
                }
              }
            });
          data.participation = limit(data.participation, 0, 100);
        }
      }
      return data;
    });
  }

  /**
   *
   * Motivation Reduction Lack of Celebration of “Quick Wins”
   * @param stakeholders
   */
  calculateMotivationReduction(stakeholders) {
    return stakeholders.map(each => {
      if (!this.history || !testStakeholderIsStaff(each)) return each;
      const data = {...each};
      const startIndex = this.history.findIndex(item => item.id === 'E1');
      if (startIndex >= 0) {
        const weeksCount = this.history.slice(startIndex+1)
          .map(item => item.weeks_required).reduce((a, b) => a+b, 0);
        const celebrationIndex = this.history.findIndex(item => item.celebration);
        if (celebrationIndex < startIndex && weeksCount >= 8) {
          data.motivation -= 5;
          data.motivation = limit(data.motivation, 0, 100);
        }
      }
      return data;
    });
  }

  /**
   *
   * @returns {T[]}
   * @private
   */
  _getLocationStaff() {
    return this.location.stakeholders.filter(each => testStakeholderIsStaff(each));
  }

  /**
   *
   * @returns {number}
   * @private
   */
  _calculateAvgStaffMotivation() {
    const staff = this._getLocationStaff();
    const totalStaffMotivation = staff.map(each => each.motivation).reduce((a, b) => a + b, 0);
    return totalStaffMotivation / staff.length;
  }

  /**
   *
   * @param id
   * @returns {*|boolean}
   * @private
   */
  _historyContainsAction(id) {
    return this.history && this.history.findIndex(each => each.id === id) >= 0;
  }

  /**
   *
   * @param id
   * @returns {number|*}
   * @private
   */
  _calculateWeeksPassedAfterAction(id) {
    if (this.history) {
      const index = this.history.findIndex(each => each.id === id);
      const historySlice = this.history.slice(index + 1);
      return historySlice.map(each => each.weeks_required).reduce((a, b) => a + b, 0);
    }
    return 0;
  }
}
